import { mapState } from 'vuex';
import CONST from '@/utils/Constants'
import eventBus from '@/config/EventBus';
import LayoutGreenScreen from "@/layouts/green-screen/layout-green-screen.vue"
import oButton from "@/objects/o-button/o-button.vue"
import oPolaroid from "@/objects/o-polaroid/o-polaroid.vue"

export default {
  name: "vInventionReady",
  components: {
    "layout-green-screen": LayoutGreenScreen,
    "o-button": oButton,
    "o-polaroid": oPolaroid
  },
  data() {
    return {}
  },
  methods: {
    stop() {
      eventBus.$emit(CONST.EVENT.INVENTION.STOPPED);
    }
  },
  computed: {
    ...mapState(['locale']),
    content() {
      return this.$store.getters.content;
    },
    src() {
      return this.$store.state.invention;
    }
  }
}
